import type { TextSwatch } from '@frontend/libs/types/product'

import { Button, cn, Tooltip } from '@nextui-org/react'

import type { SwatchProps } from './Swatch'

export type TextSwatchProps = {
  item: TextSwatch
} & Pick<SwatchProps, 'onClick' | 'option' | 'value'>

export function TextSwatch({
  item,
  onClick,
  option,
  value,
}: Readonly<TextSwatchProps>) {
  const isSelected = value === item.slug
  const isAvailable = item.isAvailable

  const button = (
    <Button
      className={cn(`h-7 w-auto min-w-0 border border-transparent px-1`, {
        'border-primary': isSelected,
        'line-through opacity-25': !isAvailable,
      })}
      color="primary"
      key={item.slug}
      onClick={() => onClick({ [option.slug]: item.slug })}
      radius="none"
      size="sm"
      type="button"
      variant={isSelected ? 'solid' : 'light'}
    >
      {item.label}
    </Button>
  )

  if (item.enableTooltip) {
    return (
      <Tooltip
        color="primary"
        content={item.label}
        key={item.slug}
        showArrow={true}
      >
        {button}
      </Tooltip>
    )
  }

  return button
}

export default TextSwatch
